/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import { gql } from '@apollo/client'
import * as Types from '../../../../../graphql/src/lib/graphql/generated/types'
export type VehicleDrawerStatusBarVehicleFragment = {
  __typename?: 'Vehicle'
  id: string
  inService: boolean | null
  notInServiceReasons: Array<Types.NotInServiceReason> | null
  isSelfDriving: boolean
  pooling: {
    __typename?: 'Pooling'
    enabled: boolean
    enabledUpdatedAt: string | null
    reason: Types.PoolingReason | null
    connected: boolean | null
    connectedUpdatedAt: string | null
  } | null
  vehicleStatusTelemetry?: {
    __typename?: 'VehicleStatusVehicleTelemetry'
    signalConnectivity: {
      __typename?: 'VehicleStatusBooleanSignal'
      value: boolean
      updatedAt: string
    } | null
    cabinConnectivity: {
      __typename?: 'VehicleStatusCabinConnectivitySignal'
      connectivityState: boolean
      updatedAt: string
    } | null
    vmcConnectionStatus: {
      __typename?: 'VehicleStatusConnectionSignal'
      connected: boolean
      updatedAt: string
    } | null
  } | null
}

export const VehicleDrawerStatusBarVehicleFragmentDoc = gql`
    fragment VehicleDrawerStatusBarVehicle on Vehicle {
  id
  pooling {
    enabled
    enabledUpdatedAt
    reason
    connected
    connectedUpdatedAt
  }
  inService
  notInServiceReasons
  vehicleStatusTelemetry @include(if: $withAdTelemetryData) {
    signalConnectivity {
      value
      updatedAt
    }
    cabinConnectivity {
      connectivityState
      updatedAt
    }
    vmcConnectionStatus {
      connected
      updatedAt
    }
  }
  isSelfDriving
}
    `
